import { toSnakeCase } from './stringFormatting';

const weightMap = {
  regularWeight: 400,
  boldWeight: 500
};

const fontStyle: { [key: string]: number } = {
  regularWeight: 400
};

Object.entries(weightMap).forEach(([key, value]) => {
  fontStyle[toSnakeCase(key)] = value as number;
});

export default fontStyle;
